import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import {DEFAULT_PAGE_SIZE, LOCAL_STORAGE_USER_LOGIN_INFO} from '@app/constants/Common';
import TableListPaging from '@app/components/TableListPaging';
import CampaignListTable from '@pages/Campaign/CampaignListTable';
import {requestListCampaigns} from '@app/services/MailService';

const CampaignList = () => {
    const [campaignList, setCampaignList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(1);
    const [showAll, setShowAll] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, []);

    const fetchCampaigns = async (showAllParam) => {
        setIsLoading(true)
        try {
            // apiRequest's response interceptor already unwraps axios's response.data
            const data = await requestListCampaigns(showAllParam);
            const items = (Array.isArray(data) ? data : []).map((item, index) => {
                item.no = index + 1
                return item
            });
            setCampaignList(items);
            setTotalCount(items.length)
            setNumberPages(Math.max(Math.ceil(items.length / DEFAULT_PAGE_SIZE), 1))
            setCurrentPage(1)
        } catch (err) {
            toast.error('Không tải được danh sách campaign!')
        } finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {
        fetchCampaigns(showAll)
    }, [showAll]);

    const onChangeShowAll = (event) => {
        setShowAll(event.target.checked)
    };

    const nextPage = () => {
        let currPage = currentPage + 1
        if (currPage > numberPages) {
            currPage = numberPages
        }
        setCurrentPage(currPage)
    };

    const backPage = () => {
        let currPage = currentPage - 1
        if (currPage < 1) {
            currPage = 1
        }
        setCurrentPage(currPage)
    };

    const pagedCampaigns = campaignList.slice(
        (currentPage - 1) * DEFAULT_PAGE_SIZE,
        currentPage * DEFAULT_PAGE_SIZE
    )

    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h3 className="card-title text-bold mt-2">Kho Campaign ({totalCount})</h3>
                    {totalCount > 0 &&
                    <h3 className='card-title text-bold ml-3 mt-2'>Page: {currentPage}/{numberPages}</h3>
                    }

                    <div className={'card-tools row'}>
                        {/*<button type={"button"}*/}
                        {/*        onClick={fetchCampaigns}*/}
                        {/*        className={'btn btn-default'}>Reload*/}
                        {/*</button>*/}
                        {userLoginInfo.is_superuser &&
                        <div className={"form-check mt-3 ml-2"}>
                            <input type={"checkbox"}
                                   id={"showAllCampaigns"}
                                   className={"form-check-input"}
                                   checked={showAll}
                                   onChange={onChangeShowAll}/>
                            <label className={"form-check-label"} htmlFor={"showAllCampaigns"}>Show all</label>
                        </div>
                        }
                        {numberPages > 1 &&
                        <div className={"mt-2 ml-2"}>
                            <TableListPaging onBack={backPage} onNext={nextPage}/>
                        </div>
                        }
                    </div>
                    {isLoading &&
                    <div className={'col-sm-12 text-center'}
                         style={{
                             position: 'absolute',
                             top: '50%',
                             left: '50%',
                             transform: 'translate(-50%, -50%)'
                         }}>
                        <div className='spinner-grow text-primary' role='status'>
                            <span className='sr-only'>Loading...</span>
                        </div>
                    </div>
                    }
                </div>
                <div className="card-body p-0">
                    <CampaignListTable campaigns={pagedCampaigns}/>
                </div>
            </div>
        </>
    );
};

export default CampaignList;
